// Renderiza emojis unicode como imagens do set Emojitwo (fork do EmojiOne, o mais
// parecido com o WhatsApp), auto-hospedado em /emojitwo/ (ver public/emojitwo).
// Deixa os emojis idênticos em qualquer SO/navegador do atendente.

const BASE = '/emojitwo/';

// converte uma sequência de emoji para o nome do arquivo (codepoints em hex).
const toCodePoint = str => {
  const r = [];
  let c = 0;
  let p = 0;
  let i = 0;
  while (i < str.length) {
    c = str.charCodeAt(i);
    i += 1;
    if (p) {
      r.push((0x10000 + (p - 0xd800) * 0x400 + (c - 0xdc00)).toString(16));
      p = 0;
    } else if (c >= 0xd800 && c <= 0xdbff) {
      p = c;
    } else {
      r.push(c.toString(16));
    }
  }
  return r.join('-');
};

// Emojitwo (EmojiOne 2.x) tira o seletor de variação FE0F quando não há ZWJ.
const filenameFor = emoji => {
  const hasZwj = emoji.includes('‍');
  let cp = toCodePoint(emoji);
  if (!hasZwj) {
    cp = cp
      .split('-')
      .filter(part => part !== 'fe0f')
      .join('-');
  }
  return cp;
};

// regex que casa emojis completos (inclui sequências ZWJ). Usa RGI_Emoji (flag v)
// quando disponível; senão cai num fallback razoável.
let EMOJI_RE;
try {
  // construtor de propósito: o literal com a flag v quebra o parse em navegadores antigos
  // eslint-disable-next-line prefer-regex-literals
  EMOJI_RE = new RegExp('\\p{RGI_Emoji}', 'gv');
} catch (e) {
  EMOJI_RE = /(\p{Extended_Pictographic}(‍\p{Extended_Pictographic})*[️⃣]?)/gu;
}

export const isEmojiSupported = () => true;

export const emojiSrc = emoji => `${BASE}${filenameFor(emoji)}.svg`;

// cria o <img> de um emoji, com fallback pro texto se o arquivo não existir.
export const createEmojiImg = (doc, emoji) => {
  const img = doc.createElement('img');
  img.className = 'emojitwo';
  img.src = emojiSrc(emoji);
  img.alt = emoji;
  img.draggable = false;
  img.setAttribute('loading', 'lazy');
  img.addEventListener('error', () => {
    img.replaceWith(doc.createTextNode(emoji));
  });
  return img;
};

// substitui emojis por <img> APENAS nos nós de texto de um elemento (não mexe em
// tags/atributos), preservando o resto do HTML. Idempotente (pula imgs já feitos).
export const emojifyElement = el => {
  if (!el || typeof document === 'undefined') return;
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
    acceptNode: node => {
      if (!node.nodeValue || !EMOJI_RE.test(node.nodeValue)) {
        return NodeFilter.FILTER_REJECT;
      }
      // não reprocessa dentro de imagens/scripts
      const tag = node.parentNode?.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'IMG') {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const targets = [];
  let n = walker.nextNode();
  while (n) {
    targets.push(n);
    n = walker.nextNode();
  }

  targets.forEach(node => {
    const text = node.nodeValue;
    EMOJI_RE.lastIndex = 0;
    if (!EMOJI_RE.test(text)) return;

    const frag = document.createDocumentFragment();
    let last = 0;
    EMOJI_RE.lastIndex = 0;
    let m = EMOJI_RE.exec(text);
    while (m) {
      if (m.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      }
      frag.appendChild(createEmojiImg(document, m[0]));
      last = m.index + m[0].length;
      m = EMOJI_RE.exec(text);
    }
    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }
    node.parentNode.replaceChild(frag, node);
  });
};

// diretiva Vue: v-emojitwo → roda emojifyElement no mount e a cada update.
export const EmojitwoDirective = {
  mounted: el => emojifyElement(el),
  updated: el => emojifyElement(el),
};
